<template>
    <el-select v-model="selectedSiloId" v-loading="loading" @change="updateSelected">
        <el-option
                v-for="item in silos"
                :key="item.id"
                :label="item.nombre"
                :value="item.id"
        >
        </el-option>
    </el-select>
</template>

<script>
    import api from "../../utils/api/api";

    export default {
        name: "siloPicker",
        props: {
            site: {
                type: Object
            },
            onSiloSelected: {
                type: Function
            }
        },
        data: function () {
            return {
                loading: true,
                selectedSiloId: undefined,
                silos: []
            }
        },
        watch: {
            site: function (newVal) {
                if (newVal === undefined) {
                    return;
                }
                this.loading = true;
                api.getSilos(newVal.id).then(value => {
                    this.silos = value.silos;
                    if (this.silos.length > 0) {
                        this.selectedSiloId = this.silos[0].id;
                        this.updateSelected(this.selectedSiloId);
                    }

                    this.loading = false;
                }).catch(reason => {
                    console.error("Error al traer silos", reason);
                    this.loading = false;
                })
            }
        },
        methods: {
            updateSelected(selected) {
                let silo = this.silos.find(value => {
                    return value.id === selected
                });

                if (this.onSiloSelected) {
                    this.onSiloSelected(silo);
                }

            }
        }
    }
</script>

<style scoped>

</style>